import styled from '@emotion/styled'

interface IInputProps {
  bold?: boolean
  proposalStyle?: boolean
  valueLeft?: boolean
}

export const InsuranceBlockParentDiv = styled.div`
    label: InsuranceBlockParentDiv;
    display: flex;    
    align-items: start;
    100%;
`

export const InsuranceBlockTextDiv = styled.div`
  label: InsuranceBlockTextDiv;
  display: flex;
  flex-direction: column;
  margin-left: 6px;
  width: 100%;
`

export const InsuranceBlockFirstTextRow = styled.div`
  label: InsuranceBlockFirstTextRow;
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const AddOnInsuranceTitle = styled.div<IInputProps>`
  label: AddOnInsuranceTitle;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  margin-right: 6px;
  font-weight: ${(props) =>
    props.bold ? (props.theme.brand === 'Maxxia' ? 700 : 900) : 400};
`

export const CardValue = styled.div<IInputProps>`
  label: CardValue;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  text-align: ${(props) => (props.valueLeft ? 'left' : 'right')};
  min-width: 100px;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
`

export const AddOnInsuranceSubText = styled.div`
  label: AddOnInsuranceSubText;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '14px' : '16px')};
  margin: 3px 0;
`

export const AddOnInsuranceLearnMore = styled.a<IInputProps>`
  label: AddOnInsuranceLearnMore;
  color: ${(props) =>
    props.proposalStyle
      ? props.theme.colors.textDarkblack
      : props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.primary} !important;
  font-size: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? '14px'
      : props.proposalStyle
      ? '16px'
      : '18px'};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? '400' : '900')};
  text-decoration: ${(props) => (props.proposalStyle ? 'underline' : 'none')};
`
